import { render } from "./ProjectsGrid.vue?vue&type=template&id=686bf499&ts=true"
import script from "./ProjectsGrid.vue?vue&type=script&lang=ts"
export * from "./ProjectsGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__